module.exports = __webpack_public_path__ + "img/background.e79ac940.png";